import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ServiceDeliveryRequest, ServiceDeliveryResponse, ServiceDeliveryStatus } from './service-delivery-report.models';

@Injectable({ providedIn: 'root' })
export class ServiceDeliveryReportApiService {
  async load(endpoint: string, payload: ServiceDeliveryRequest): Promise<ServiceDeliveryResponse> {
    const response = await axios.post(endpoint, payload);
    const data: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      const status = data as ServiceDeliveryStatus;
      if (status.ISSessionExpired || status.ISessionExpired || status.iResult === 0) return status;
    }
    throw new Error('پاسخ گزارش نامعتبر است');
  }
}
